import BUY_ACCOUNT from "@assets/images/widgets/acheter-un-compte-lol-niveau-30-secret-smurfs.png";
import ButtonVariants from "@core-components/button/ButtonVariants";
import Icon from "@core-components/icon/Icon";
import ProductDetailLine from "@core-components/product-detail-line/ProductDetailLine";
import SSHeadline from "@core-components/title/SSHeadline";
import SSWhiteText from "@core-components/title/components/SSWhiteText";
import EPublicRoutes from "@core-types/routes.enum";
import useAppLanguage from "@hooks/language/useAppLanguage";
import { Card, Group } from "@mantine/core";
import { IconBolt } from "@tabler/icons-react";

const BuyAccountWidget: React.FC = () => {
  const { locationUrlBuilder } = useAppLanguage();

  return (
    <Card
      withBorder
      className="hover-scale"
      classNames={{
        root: "bg-primary-default border-primary-lighter max-w-[800px] md:p-5 background-image-[var(--image-url)]",
      }}
      padding="xs"
      radius="md"
      shadow="sm"
      styles={{
        root: {
          "--image-url": `url(${BUY_ACCOUNT})`,
        } as React.CSSProperties,
      }}
    >
      <div className="flex w-full flex-col md:flex-row">
        <div className="">
          <SSHeadline
            props={{
              stack: {
                align: "left",
              },
              title: {
                order: 3,
                ff: "unset",
              },
            }}
          >
            <SSWhiteText>Achète un nouveau compte LoL</SSWhiteText>
          </SSHeadline>
          <p className="my-4 text-primary-light-text">
            Offre-toi l&apos;excellence avec nos comptes League of Legends, tous
            de niveau 30 et prêts pour les classées.
          </p>
          <ButtonVariants.Gradient
            isFullWidth
            className="hover-scale hidden rounded-md md:block"
            href={locationUrlBuilder(EPublicRoutes.SMURFS_NORMAL)}
            label={
              <Group justify="center">
                <Icon.AddToBasket size={20} />
                Découvrir les comptes
              </Group>
            }
          />
        </div>
        <div className="md:flex md:w-1/2 md:min-w-[325px] md:flex-col md:justify-between md:self-stretch md:px-4">
          <ProductDetailLine
            color="#8700B6"
            description={""}
            icon={IconBolt}
            label="Level 30+"
          />
          <ProductDetailLine
            color="#B60000"
            description={""}
            icon={IconBolt}
            label="Livraison instantanée !"
          />
          <ProductDetailLine
            color="#003EB6"
            description={""}
            icon={IconBolt}
            label="Email et mot de passe modifiables"
          />
          <ProductDetailLine
            color="#00B61D"
            description={""}
            icon={IconBolt}
            label="Toutes saisons non classées"
          />
        </div>
      </div>
      <ButtonVariants.Gradient
        className="hover-scale mt-4 rounded-md md:hidden"
        href={locationUrlBuilder(EPublicRoutes.SMURFS_NORMAL)}
        label={
          <Group justify="center">
            <Icon.AddToBasket size={20} />
            Découvrir les comptes
          </Group>
        }
      />
    </Card>
  );
};

export default BuyAccountWidget;
